function isHtml(text?: string): boolean {
  text = text?.trim().toLowerCase() ?? ''
  return text.startsWith('<!doctype') || text.startsWith('<html')
}

export class HttpError extends Error {
  readonly status: number
  readonly text?: string

  constructor(status: number, text?: string) {
    if (isHtml(text)) text = undefined

    const message = text ? status + ' ' + text : status + ''
    super(message)
    this.status = status
    this.text = text
  }
}
